import type { Locale } from '@alltrails/types/Locale';
import { getLanguageRegionCodeFromLocale } from '@alltrails/shared/utils/languageSupport';

const namespace = process.env.NEXT_PUBLIC_DEPLOY_NAMESPACE;

export const OsanoLanguageMap = {
  ['en-US']: 'en',
  ['en-GB']: 'en-gb',
  ['da-DK']: 'da',
  ['de-DE']: 'de',
  ['es-ES']: 'es',
  ['es-MX']: 'es-mx',
  ['fr-FR']: 'fr',
  ['it-IT']: 'it',
  ['nl-NL']: 'nl',
  ['nb-NO']: 'nb',
  ['pl-PL']: 'pl',
  ['pt-PT']: 'pt',
  ['pt-BR']: 'pt-br',
  ['sv-SE']: 'sv'
};

export const getOsanoLocale = (locale: Locale) => {
  const languageRegionCode = getLanguageRegionCodeFromLocale(locale);
  return OsanoLanguageMap[languageRegionCode] || 'en-gb';
};

export const getOsanoSrc = (locale: Locale) => {
  const osanoLocale = getOsanoLocale(locale);

  if (namespace === 'production') {
    return `https://cmp.osano.com/AzZqakTb9cVIa3Ok9/ca957679-3953-4131-9f80-8e7ef8f97a4f/osano.js?language=${osanoLocale}`;
  }

  return `https://cmp.osano.com/AzZqakTb9cVIa3Ok9/4897ac6f-6a9c-456e-b7e0-5a4b3852f44e/osano.js?language=${osanoLocale}`;
};
